import React, { useEffect, useState } from 'react';
import HeaderBRK from '../components/HeaderBRKmobile';
import ClientMobileMenuDrawer from '../drawers/ClientMobileMenuDrawer';
import BackdropMobile from '../backdrop/BackdropMobile';
import Footer from '../components/Footer';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  POLO_SHIRTS_MEN_ESSENTIALS_BRK,
  MIDLAYERS_MEN_ESSENTIALS_BRK,
  VEST_MEN_ESSENTIALS_BRK,
} from './data-essentials_men';
import {
  POLO_SHIRTS_WOMEN_ESSENTIALS_BRK,
  MIDLAYERS_WOMEN_ESSENTIALS_BRK,
  VEST_WOMEN_ESSENTIALS_BRK,
} from './data-essentials_women';
import { SectionItem } from '../components/essentials/SectionItem';

const categoryItems = [
  {
    title: 'POLO SHIRTS',
    description:
      'Our polo shirts are more than a classic—they’re a refined staple crafted for movement, breathability, and year-round appeal. Designed with performance fabrics and modern silhouettes, they offer the comfort golfers demand with the elegance your shop is known for. A core item with high turnover, ideal for players who value both form and function.',
  },
  {
    title: 'MID LAYERS',
    description:
      'Lightweight warmth. Streamlined design. Our midlayers are built for layering without bulk—perfect for cool mornings, unpredictable rounds, and transitional style. With clean lines and smart details, they offer both comfort and polish. Essential for golfers who want to play through the elements without sacrificing their look.',
  },
  {
    title: 'VEST AND WINDSTOPPER',
    description:
      'The vest and windstopper is a must-have for any serious golfer—and your shop. BRK vests and windstopper offer core warmth and wind resistance while maintaining full mobility. With subtle finishes and a modern fit, they transition effortlessly from course to clubhouse. Functional, stylish, and highly versatile: a customer favorite with strong repeat potential.',
  },
];

function Essentials() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { gender } = useParams(); // will be "men" or "women"

  // Add this useEffect
  useEffect(() => {
    // Close mobile menu when gender route param changes
    setIsMobileMenuOpen(false);
  }, [gender]);

  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  const navigate = useNavigate();

  return (
    <>
      {/******************* COMMON - REFACTOR ***************************/}
      {/* <Header /> */}
      <HeaderBRK openMobileMenu={openMobileMenu} />
      <ClientMobileMenuDrawer show={isMobileMenuOpen} />
      {isMobileMenuOpen && <BackdropMobile onClick={closeMobileMenu} />}
      {/******************* COMMON - REFACTOR ***************************/}

      <div className="container-essentials-brk">
        <header className="header-essentials-brk">
          <h1>TIMELESS. ESSENTIAL.</h1>
          <p>
            Our Essentials combine top-tier quality with year-round demand.
            Trusted by golfers, chosen by pros, and made for shops that expect
            more.
          </p>
        </header>
        <SectionItem
          products={
            gender === 'men'
              ? POLO_SHIRTS_MEN_ESSENTIALS_BRK
              : POLO_SHIRTS_WOMEN_ESSENTIALS_BRK
          }
          category={categoryItems[0]}
          banner_performance={true}
        />
        <SectionItem
          products={
            gender === 'men'
              ? MIDLAYERS_MEN_ESSENTIALS_BRK
              : MIDLAYERS_WOMEN_ESSENTIALS_BRK
          }
          category={categoryItems[1]}
          banner_performance={true}
        />

        {gender === 'men' && (
          <SectionItem
            products={VEST_MEN_ESSENTIALS_BRK}
            category={categoryItems[2]}
            banner_performance={true}
          />
        )}

        <div className="section-a-different-view">
          <h1>A DIFFERENT VIEW, THE SAME SPIRIT</h1>
          <p>
            Discover how elegance and performance come together—expressed in a
            different way, but with the same passion for golf.
          </p>
          {gender === 'men' ? (
            <button
              className="btn-explore-essentials"
              onClick={() => navigate('/essentials/women')}
            >
              Explore Women
            </button>
          ) : (
            <button
              className="btn-explore-essentials"
              onClick={() => navigate('/essentials/men')}
            >
              Explore Men
            </button>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Essentials;
